const UPDATE_READY_EVENT = "sedulur-dalan-update-ready";

function announceUpdate(registration) {
  if (!registration?.waiting) return;
  globalThis.dispatchEvent?.(new CustomEvent(UPDATE_READY_EVENT, { detail: { registration } }));
}

export async function registerDriverPwa() {
  if (!("serviceWorker" in navigator)) return null;
  const registration = await navigator.serviceWorker.register("/driver-sw.js", { scope: "/sedulurdalan/" });
  announceUpdate(registration);
  registration.addEventListener("updatefound", () => {
    const installing = registration.installing;
    installing?.addEventListener("statechange", () => {
      if (installing.state === "installed" && navigator.serviceWorker.controller) announceUpdate(registration);
    });
  });
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "DRIVER_UPDATE_READY") announceUpdate(registration);
  });
  return registration;
}

export function subscribeDriverPwaUpdate(listener) {
  const handler = (event) => listener(event.detail?.registration || null);
  globalThis.addEventListener?.(UPDATE_READY_EVENT, handler);
  return () => globalThis.removeEventListener?.(UPDATE_READY_EVENT, handler);
}

export function activateDriverPwaUpdate(registration) {
  let reloading = false;
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    globalThis.location?.reload();
  }, { once: true });
  registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
}
